import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="border-b border-line bg-night px-4 py-14 sm:px-6 sm:py-20" data-id="element-232" data-mp="3fycqrnqb67bb">
      <SectionHeading eyebrow="Témoignages réels" title="Ce que disent les médecins qui utilisent déjà Route Maladie Rénale™" data-id="element-233" data-mp="3b1ch72u92mfg" />

      <ul className="mx-auto mt-10 grid w-full max-w-5xl grid-cols-1 gap-4 lg:grid-cols-2" data-id="element-234" data-mp="36wmofmuw1nyr">
        {testimonials.map(testimonial => <li key={testimonial.name} className="flex flex-col rounded-2xl border border-line bg-surface p-5 sm:p-6" data-id="element-235" data-mp="2x00552i7n4yu">
            <QuoteIcon className="h-6 w-6 shrink-0 text-lime" aria-hidden="true" data-id="element-236" data-mp="2s3taw6z6fhwq" />
            <blockquote className="mt-3 flex-1 text-[15px] leading-relaxed text-slate-200" data-id="element-237" data-mp="v8ndhf596tkq">
              « {testimonial.quote} »
            </blockquote>
            <div className="mt-auto flex items-center gap-3 pt-5" data-id="element-238" data-mp="h5ezpnh15z1q">
              <img src={testimonial.photo} alt={`Portrait du ${testimonial.name}`} className="h-12 w-12 shrink-0 rounded-full object-cover" width={96} height={96} loading="lazy" data-id="element-239" data-mp="h8awv9l20jp4" />
              <div className="min-w-0" data-id="element-240" data-mp="c8y304vrmcd1">
                <p className="text-[14px] font-bold text-white" data-id="element-241" data-mp="zvwh4vwex87s">{testimonial.name}</p>
                <p className="text-[13px] text-slate-400" data-id="element-242" data-mp="14v9b00lpbfjv">{testimonial.country}</p>
              </div>
            </div>
          </li>)}
      </ul>

      <div className="mx-auto mt-10 max-w-xl" data-id="element-243" data-mp="q6cudf5kwu7n">
        <CTAButton label="Je veux obtenir les mêmes résultats" caption="Rejoignez plus de 1 000 médecins hispanophones" data-id="element-244" data-mp="v5fy8w9toue1" />
      </div>
    </section>;
}